import { mutations as MUTATION, actions as ACTION } from "./types";
import { Api, ApiUrl } from "../../services";
import obsLocalData from "@/utils/obsLocalData.js";

const actions = {
  [ACTION.OBS_SUBMIT_SURVEYINFO]: async (store, { data, status, shopifyDomain }) => {
    return new Promise(async (resolve, reject) => {
      let dataSubmit = {
        data: data,
        status: (status !== "skip") ? "final" : "skip"
      };
      if (status == "step4") {
        obsLocalData.set(true, "almostDoneFail", shopifyDomain);
      } else if (status == "final") {
        obsLocalData.set(true, "subscribedFail", shopifyDomain);
      }
      try {
        let res = await Api.base.post(ApiUrl.base.onboardingStep.surveyInfo, dataSubmit);
        if (res.data.status == true || res.data.status == "success") {
          store.commit(MUTATION.OBS_UPDATE_STATUS, {
            success: true
          });
          setTimeout(() => {
            obsLocalData.remove(shopifyDomain);
            store.commit(MUTATION.OBS_UPDATE_STATUS, {
              success: false
            });
          }, 2000);
          resolve();
        } else {
          throw res;
        }
      }
      catch (err) {
        if (status == "final") {
          obsLocalData.set(data, "dataSubcribeSubmit", shopifyDomain)
        } else if (status == "step4") {
          obsLocalData.set(data, "dataSubmit", shopifyDomain)
        }
        store.commit(MUTATION.OBS_UPDATE_STATUS, {
          error: true
        });
        reject(err);
      }
    })
  }
};

export default actions;
